import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.25 8.5L2.25 5.5L0 7.75L5.25 13L15 3.25L12.75 1L5.25 8.5Z",
		fill: "currentColor"
	})
});
export default SvgIconTick;
